import { IHotel } from '@entities/hotel';
import { RestTypeFilterItem } from '../types';

export default function (hotel: IHotel, restTypeFilterId: RestTypeFilterItem['id'] | 0 = 0): boolean {
    if (!restTypeFilterId) return true;

    return hotel.restTypes.includes(restTypeFilterId);
}
